var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"readonly":_vm.readonly,"disabled":_vm.disabled,"label":_vm.label,"items":_vm.weekdays,"error":_vm.error,"rules":_vm.rules,"multiple":_vm.multiple},model:{value:(_vm.select),callback:function ($$v) {_vm.select=$$v},expression:"select"}})
}
var staticRenderFns = []

export { render, staticRenderFns }